import { createFileRoute, redirect } from '@tanstack/react-router';

// Legacy deep link. The old /vault/folder/<name> (by-name) view has been retired in favour of the
// folder tree, so any old bookmark/shared link just lands on the vault root (All files).
export const Route = createFileRoute('/vault_/folder/$folder')({
  beforeLoad: () => {
    throw redirect({ to: '/vault' });
  },
});
